import { Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import ConnectWithStravaLogo from "../../assets/btn_strava_connectwith_orange.svg";
import type ConnectedService from "../../domain/ConnectedService";

interface ConnectButtonProps {
  connectedService: ConnectedService;
  connect: () => void;
}

const ConnectButton: React.FC<ConnectButtonProps> = ({ connectedService, connect }) => {
  const { t } = useTranslation();

  if (connectedService.serviceName === "Strava") {
    return (
      <Button variant="connectWithStrava" colorScheme="cyan" mt={4} onClick={connect}>
        <img src={ConnectWithStravaLogo} alt="ConnectWithStrava" />
      </Button>
    );
  } else {
    return (
      <Button colorScheme="cyan" variant="outline" mt={4} onClick={connect}>
        {t("Connect")}
      </Button>
    );
  }
};

export default ConnectButton;
